import { render, staticRenderFns } from "./ProformDataPopup.vue?vue&type=template&id=565b451a&scoped=true"
import script from "./ProformDataPopup.vue?vue&type=script&lang=js"
export * from "./ProformDataPopup.vue?vue&type=script&lang=js"
import style0 from "./ProformDataPopup.vue?vue&type=style&index=0&id=565b451a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b451a",
  null
  
)

export default component.exports